import { render, staticRenderFns } from "./ClientsAccountingList.vue?vue&type=template&id=57e19f16&"
import script from "./ClientsAccountingList.vue?vue&type=script&lang=js&"
export * from "./ClientsAccountingList.vue?vue&type=script&lang=js&"
import style0 from "./ClientsAccountingList.vue?vue&type=style&index=0&id=57e19f16&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports